import { getApiGatewayUrls } from './apiGatewayUtils';

const DEFAULT_SDK_URL =
    'https://main.feat-test.built-in-support.integration.concursolutions.com/dsx-everywhere-sdk/sdk-react-dsx-everywhere.js';

const HOST_TO_SDK_URL = {
    localhost: DEFAULT_SDK_URL,
    'us2.concursolutions.com': DEFAULT_SDK_URL,
    'integration.concursolutions.com':
        'https://main.feat-test.built-in-support.integration.concursolutions.com/dsx-everywhere-sdk/sdk-react-dsx-everywhere.js',
    'eu2.concursolutions.com': DEFAULT_SDK_URL,
    'apj1.concursolutions.com': DEFAULT_SDK_URL,
};

const getSdkUrl = () => HOST_TO_SDK_URL[window?.location?.hostname] ?? DEFAULT_SDK_URL;

let sdk$;
function getSDK() {
    if (!sdk$) {
        const sdkUrl = getSdkUrl();
        sdk$ = new Promise((resolve, reject) => {
            const el = document.createElement('script');
            const container = document.head || document.body;
            el.async = true;
            el.src = sdkUrl;
            el.addEventListener('load', () => resolve(window['sdk-react-dsx-everywhere']));
            el.addEventListener('error', () =>
                reject(new Error(`Failed to load the script ${sdkUrl}`)),
            );
            container.appendChild(el);
        });
    }
    return sdk$;
}

function getProxyServiceUrl() {
    if (window.location.hostname === 'localhost') {
        return `${window.location.protocol}//${window.location.hostname}:${window.location.port}/api-gw/cmc-preview/bis/token`;
    }
    return `https://${getApiGatewayUrls().apigwBrowserUrl}/cmc-preview/bis/token`;
}

let bisCleanup = null;

export async function loadSDK(headerBottom, bisConfig = {}) {
    const sdk = await getSDK();
    sdk.create({
        topOffset: `${headerBottom}px`,
        baseUrl: new URL(getSdkUrl()).origin,
        zIndex: 996,
        useIcon: false,
        getProductContext: async () => ({
            isRoleBasedIntegration: true,
            productName: bisConfig.productName ?? '',
            helpPortalProductID: '',
            leadingPPMSID: '',
            PPMSIDs: ['', '', '', ''],
            productFallbackACH: '',
            productSupportACH: '',
        }),
        getSystemContext: async () => ({
            // globalTenantId: '', // TODO
            systemRole: 'Concur',
        }),
        getApplicationContext: async () => ({
            applicationName: '',
            achComponent: '',
            appUrl: window.location.pathname,
            moduleId: '',
            pageId: '',
            pageSubId: '',
        }),
        getAdditionalContext: async () => {
            const match = window.location.pathname.match(/expense\/reports\/([^/?#]+)/);
            return match ? { supportInformation: { reportId: match[1] } } : {};
        },
    });

    bisCleanup = sdk.subscribeSecureTokenExchange({
        getToken: async () => {
            const response = await fetch(getProxyServiceUrl(), {
                method: 'POST',
                credentials: 'include',
            });
            if (!response.ok) {
                const errorBody = await response.json();
                throw Object.assign(new Error('Failed to retrieve BIS token'), {
                    errorResponseBody: errorBody,
                });
            }
            const data = await response.json();
            return data.token;
        },
    });
}

export async function destroySDK() {
    if (bisCleanup) {
        bisCleanup();
        bisCleanup = null;
    }
    if (!sdk$) return;
    const sdk = await getSDK();
    if (sdk.isInitialized()) {
        sdk.destroy();
    }
}
